import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const TemperatureColoredIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0  331.7 338.58" style={{ color, fontSize, ...style }} {...rest}>
      <path
        style={{ fill: '#4292e7' }}
        d="M160.41,330.66c-3.32-2.88-2.94-5.97-0.99-9.55c3.08-5.64,5.78-11.49,8.68-17.23c1.82-3.6,4.14-4.6,7.08-3.15
	c2.48,1.22,3.11,4.16,1.5,7.44c-3.12,6.33-6.35,12.62-9.43,18.97c-0.73,1.5-1.89,2.47-3.04,3.52
	C162.94,330.66,161.67,330.66,160.41,330.66z"
      />
      <path
        style={{ fill: '#4292e7' }}
        d="M107.84,330.66c-3.26-2.9-2.92-5.96-0.95-9.55c3.09-5.63,5.78-11.47,8.67-17.21c1.71-3.39,4.37-4.54,7.12-3.15
	c2.44,1.23,3.06,4.19,1.45,7.46c-3.12,6.33-6.34,12.61-9.42,18.96c-0.73,1.49-1.88,2.48-3.06,3.5
	C110.37,330.66,109.11,330.66,107.84,330.66z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M195.25,241.98c-45.81,0-91.62,0.1-137.43-0.06c-12.46-0.04-23.69-4.21-33.42-12.14
	c-10.96-8.93-17.45-20.58-18.97-34.45c-1.57-14.3,2.16-27.44,11.44-38.85c7.61-9.37,17.29-15.19,28.88-18.01
	c2.43-0.59,4.91-1,7.46-1.03c3.92-0.06,4.44-0.82,4.61-4.64c0.49-10.55,4.53-19.78,10.88-28.05c8.93-11.64,21.05-17.7,35.33-19.84
	c0.4,0.62,1.07,0.54,1.68,0.69c20.07,5.12,33.11,17.69,39.57,37.27c1.87,5.65,1.61,11.57,2.4,17.36
	c2.05,14.99,15.37,19.81,28.55,16.88c2.76,0.6,5.54,0.83,8.37,0.8c4.17-0.04,8.34,0.03,12.51,0.05c0.17,0.95,0.93,0.93,1.66,1.12
	c7.63,1.9,14.43,5.52,19.86,11.12c9.5,9.78,14.1,21.43,12.08,35.28c-2.32,15.96-11.13,26.89-25.71,33.31
	C201.9,240.15,198.52,240.93,195.25,241.98z"
      />
      <path
        style={{ fill: '#ffb300' }}
        d="M197.13,157.96c-4.17-0.02-8.34-0.09-12.51-0.05c-2.82,0.03-5.61-0.2-8.37-0.8
	c-10.17-4.34-14.29-12.29-13.99-23.04c0.07-2.38-0.41-4.81-0.89-7.16c-2.96-14.28-10.9-25.27-22.53-33.78
	c10.83-20.01,27.15-32.96,49.37-38.21c3.35-0.79,6.83-1.06,10.25-1.57c0.97,0.37,1.91,0.97,2.91,1.08
	c5.06,0.55,9.85,2.02,14.54,3.89c20.74,8.29,34.82,23.07,42.43,43.97c3.94,10.82,4.91,22.01,3.51,33.51
	c-1.11,9.12-3.96,17.52-8.19,25.6c-3.41,6.51-7.98,12.07-12.89,17.42c-2.35-3.09-4.51-6.35-7.36-9.01
	C223.15,160.26,210.88,156.82,197.13,157.96z"
      />
      <path
        style={{ fill: '#ff9d00' }}
        d="M240.75,178.82c4.91-5.35,9.49-10.92,12.89-17.42c4.23-8.09,7.08-16.48,8.19-25.6
	c1.4-11.5,0.43-22.68-3.51-33.51c-7.61-20.89-21.69-35.68-42.43-43.97c-4.69-1.87-9.49-3.34-14.54-3.89c-1-0.11-1.94-0.71-2.91-1.08
	c36.96-2.88,66.88,21.16,76.2,51.88c9.25,30.48-2.6,64.42-28.86,82.01c-0.35,0.23-0.74,0.38-1.12,0.57
	C243.37,184.81,242.06,181.81,240.75,178.82z"
      />
      <path
        style={{ fill: '#EFE7E1' }}
        d="M240.75,178.82c1.31,2.99,2.61,5.99,3.92,8.98c1.09,4.73,1.48,9.51,1.25,14.35
	c-0.74,15.04-7.85,26.18-20.57,33.99c-9.33,5.73-19.62,6.18-30.1,5.84c3.27-1.05,6.65-1.83,9.78-3.21
	c14.58-6.41,23.39-17.35,25.71-33.31c2.01-13.86-2.59-25.5-12.08-35.28c-5.43-5.59-12.24-9.21-19.86-11.12
	c-0.73-0.18-1.49-0.16-1.66-1.12c13.75-1.14,26.02,2.3,36.27,11.85C236.24,172.47,238.4,175.73,240.75,178.82z"
      />
      <path
        style={{ fill: '#EFE7E1' }}
        d="M138.83,93.13c11.63,8.51,19.57,19.5,22.53,33.78c0.49,2.35,0.96,4.78,0.89,7.16
	c-0.3,10.75,3.82,18.71,13.99,23.04c-13.18,2.93-26.5-1.89-28.55-16.88c-0.79-5.78-0.53-11.7-2.4-17.36
	c-6.46-19.59-19.5-32.16-39.57-37.27c-0.6-0.15-1.28-0.07-1.68-0.69c8.18-0.21,16.36-0.32,24.06,3.1
	C131.73,89.62,135.26,91.42,138.83,93.13z"
      />
      <path
        style={{ fill: '#4292e7' }}
        d="M204.52,258.41c3.57,0.06,5.79,3.02,4.27,6.28c-3.41,7.25-7.01,14.41-10.76,21.5c-1.4,2.65-4.11,3.17-6.48,1.8
	c-2.39-1.39-3.1-3.81-1.77-6.5c3.36-6.81,6.81-13.57,10.16-20.39C200.91,259.13,202.43,258.35,204.52,258.41z"
      />
      <path
        style={{ fill: '#4292e7' }}
        d="M104.06,263.45c0.08,0.88-0.26,1.76-0.69,2.62c-3.16,6.31-6.33,12.63-9.48,18.94
	c-0.94,1.89-2.33,3.31-4.44,3.71c-3.25,0.61-6.26-3.28-4.74-6.58c3.36-7.27,7.04-14.39,10.7-21.51c1.2-2.34,3.44-2.67,5.75-1.97
	C103.4,259.34,104.16,261.12,104.06,263.45z"
      />
      <path
        style={{ fill: '#4292e7' }}
        d="M136.95,283.77c-0.09-1.15,0.19-2.14,0.68-3.1c3.12-6.21,6.22-12.44,9.35-18.64c0.82-1.62,1.84-3.17,3.78-3.52
	c1.81-0.33,3.66-0.15,4.9,1.45c1.19,1.53,1.37,3.31,0.5,5.06c-3.45,6.99-6.88,13.99-10.48,20.9c-1,1.92-2.77,3.39-5.18,2.68
	C138.19,287.92,136.65,286.4,136.95,283.77z"
      />
      <path
        style={{ fill: '#EDBA6A' }}
        d="M122.78,40.09c1.39,0.06,2.58,0.66,3.59,1.67c4.76,4.76,9.55,9.48,14.26,14.29c2.27,2.31,2.34,4.99,0.4,7
	c-1.98,2.05-4.62,2.15-6.99-0.13c-4.92-4.74-9.71-9.62-14.49-14.5c-1.5-1.53-2.04-3.38-1.06-5.49
	C119.33,41.07,120.9,40.4,122.78,40.09z"
      />
      <path
        style={{ fill: '#EDBA6A' }}
        d="M290.81,44.45c-0.03,1.91-0.78,3.17-1.84,4.24c-4.66,4.7-9.28,9.45-14.07,14.02c-2.59,2.48-5.31,2.43-7.21,0.29
	c-2.02-2.28-1.82-4.63,0.74-7.22c4.65-4.71,9.35-9.38,14.05-14.05c1.56-1.55,3.36-2.05,5.46-1.13
	C289.8,41.4,290.52,42.93,290.81,44.45z"
      />
      <path
        style={{ fill: '#EDBA6A' }}
        d="M271.35,188.71c1.54-0.15,2.69,0.71,3.77,1.79c4.54,4.56,9.11,9.07,13.63,13.65c2.53,2.57,2.72,5.05,0.7,7.24
	c-1.93,2.09-4.77,2.1-7.26-0.29c-4.78-4.61-9.45-9.33-14.09-14.08c-1.45-1.48-2.33-3.29-1.32-5.46
	C267.66,189.67,269.08,188.59,271.35,188.71z"
      />
      <path
        style={{ fill: '#EDBA6A' }}
        d="M309.26,131.2c-3.37,0-6.74,0.05-10.11-0.01c-2.96-0.05-5-1.92-5.07-4.49c-0.07-2.76,1.93-4.92,5.02-4.96
	c6.85-0.1,13.69-0.11,20.54,0.01c3.11,0.06,4.99,2.23,4.84,5.07c-0.14,2.76-1.91,4.32-5.1,4.38
	C316,131.25,312.63,131.2,309.26,131.2z"
      />
      <path
        style={{ fill: '#EDBA6A' }}
        d="M209.17,21.76c0,3.26,0.06,6.53-0.02,9.78c-0.08,3.23-1.91,5.2-4.68,5.24c-2.91,0.04-4.78-2-4.8-5.39
	c-0.04-6.52-0.04-13.05,0-19.57c0.02-3.34,1.98-5.5,4.8-5.45c2.7,0.05,4.61,2.12,4.68,5.29C209.23,15.03,209.17,18.4,209.17,21.76z"
      />
    </SvgIcon>
  )
}
export default TemperatureColoredIcon
